import React, { useEffect, useState } from 'react';
import FacultyNavbar from './FacultyNavbar'; // Import FacultyNavbar

const Department = () => {
  const [allRows, setAllRows] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [selectedClass, setSelectedClass] = useState('');
  const [filteredRows, setFilteredRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [savedStudents, setSavedStudents] = useState(
    JSON.parse(localStorage.getItem('savedStudents')) || []
  );

  useEffect(() => {
    fetch('https://backend-main-4.onrender.com/data')
      .then((response) => response.json())
      .then((data) => setAllRows(data))
      .catch((error) => console.error('Error fetching data:', error));
  }, []);

  useEffect(() => {
    if (selectedDepartment && selectedClass) {
      const filtered = allRows.filter(
        (row) =>
          row[5] === selectedDepartment && row[4] === selectedClass
      );
      setFilteredRows(filtered);
    }
  }, [selectedDepartment, selectedClass, allRows]);

  const handleSearch = (event) => {
    event.preventDefault();
    const term = searchTerm.toLowerCase();
    const results = allRows.filter((row) => {
      const rollNumber = row[0].toLowerCase();
      const name = row[1].toLowerCase();
      return rollNumber.includes(term) || name.includes(term);
    });
    setSearchResults(results);
  };

  const toggleSaveStudent = (rollNumber) => {
    const existingIndex = savedStudents.findIndex(
      (student) => student.rollNumber === rollNumber
    );

    let updatedSavedStudents;
    if (existingIndex > -1) {
      updatedSavedStudents = savedStudents.filter(
        (student) => student.rollNumber !== rollNumber
      );
    } else {
      const studentData = allRows.find((row) => row[0] === rollNumber);
      const formattedStudent = {
        fullName: studentData[1],
        rollNumber: studentData[0],
        classSection: studentData[4],
        department: studentData[5],
        isEligible:
          parseFloat(studentData[6]) > 60 &&
          parseFloat(studentData[7]) > 60 &&
          parseFloat(studentData[8]) > 60,
      };
      updatedSavedStudents = [...savedStudents, formattedStudent];
    }
    setSavedStudents(updatedSavedStudents);
    localStorage.setItem('savedStudents', JSON.stringify(updatedSavedStudents));
  };

  const renderCards = (rows) =>
    rows.map((row) => {
      const rollNumber = row[0];
      const fullName = row[1];
      const eligibilityClass =
        parseFloat(row[6]) > 60 &&
        parseFloat(row[7]) > 60 &&
        parseFloat(row[8]) > 60
          ? 'text-green-500'
          : 'text-red-500';
      const eligibilityText =
        eligibilityClass === 'text-green-500' ? 'Eligible' : 'Not Eligible';
      const isSaved = savedStudents.some(
        (student) => student.rollNumber === rollNumber
      );

      return (
        <div
          key={rollNumber}
          className="card bg-white shadow-md rounded-lg p-4 w-80 m-4"
        >
          <img
            src="https://via.placeholder.com/100"
            alt="Profile"
            className="rounded-full mx-auto mb-4"
          />
          <div className="text-center font-semibold text-lg">{fullName}</div>
          <div className="mt-2 text-sm">
            <p>Roll Number: {rollNumber}</p>
            <p>Class: {row[4]}</p>
            <p className={`${eligibilityClass}`}>
              Eligibility: {eligibilityText}
            </p>
          </div>
          <button
            className={`mt-4 w-full py-2 rounded ${
              isSaved ? 'bg-yellow-400' : 'bg-blue-500'
            } text-white`}
            onClick={() => toggleSaveStudent(rollNumber)}
          >
            {isSaved ? 'Saved' : 'Save'}
          </button>
        </div>
      );
    });

  return (
    <div className="min-h-screen bg-gray-100">
      <FacultyNavbar /> {/* Add FacultyNavbar here */}
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold text-center mb-6">
          Select Departments and Classes
        </h1>
        <div className="flex justify-center gap-4 mb-4">
          {['BCA', 'BSC IT', 'BSC CS', 'BSC CT'].map((department) => (
            <button
              key={department}
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              onClick={() => setSelectedDepartment(department)}
            >
              {department}
            </button>
          ))}
        </div>
        {selectedDepartment && (
          <div className="flex justify-center gap-4 mb-4">
            {['III - A', 'III - B', 'III - C'].map((classSection) => (
              <button
                key={classSection}
                className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                onClick={() => setSelectedClass(classSection)}
              >
                {classSection}
              </button>
            ))}
          </div>
        )}
        <form
          className="flex justify-center mb-6"
          onSubmit={handleSearch}
        >
          <input
            type="text"
            placeholder="Search by roll number or name"
            className="border border-gray-300 rounded-l px-4 py-2 w-96"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button
            type="submit"
            className="px-4 bg-blue-500 text-white rounded-r hover:bg-blue-600"
          >
            Search
          </button>
        </form>
        {searchResults.length > 0 && (
          <div className="bg-white p-4 rounded-lg shadow mb-6 relative">
            <span
              className="absolute top-2 right-2 text-xl cursor-pointer text-gray-500 hover:text-gray-700"
              onClick={() => setSearchResults([])}
            >
              &times;
            </span>
            <h2 className="text-xl font-semibold mb-4">Search Results</h2>
            <div className="flex flex-wrap justify-center">
              {renderCards(searchResults)}
            </div>
          </div>
        )}
        <div className="flex flex-wrap justify-center">
          {renderCards(filteredRows)}
        </div>
      </div>
    </div>
  );
};

export default Department;
